import { render, staticRenderFns } from "./joined.vue?vue&type=template&id=2e775ee0&scoped=true"
import script from "./joined.vue?vue&type=script&lang=js"
export * from "./joined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e775ee0",
  null
  
)

export default component.exports